import React from 'react'

const Footer = () => {
  return (
    <div className='footerText'>Made with React and 😂 by Brycen Wright</div>
  )
}

export default Footer